import React from 'react';
import { Link } from 'react-router-dom';
import { FACEBOOK_PAGE_URL } from '../constants/facebookPageUrl';
import GoogleAccreditationBanner from './GoogleAccreditationBanner';
import FooterExperienceRating from './FooterExperienceRating';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  XIcon,
} from './socialPlatformIcons';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <button className="back-to-top" onClick={scrollToTop}>
        BACK TO TOP
      </button>
      
      <div className="footer-container">
        <div className="footer-section footer-brand-block">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <span className="footer-logo-text">
                Raheasy<span className="footer-logo-period">.</span>
              </span>
            </div>
            <p className="footer-tagline">— SAVINGS MADE SIMPLE —</p>
          </div>
          <p className="footer-text">
          Raheasy is Kenya's smart shopping companion — compare deals from trusted stores across the country, 
          all in one place. Shop smarter, save bigger. 100% free for shoppers.
          </p>

          <GoogleAccreditationBanner />

          <div className="footer-social-row">
            <a href="https://www.instagram.com/raheasyke/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
              <InstagramIcon size={18} />
            </a>
            <a href="https://www.tiktok.com/@raheasy" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="footer-social-link">
              <TikTokIcon size={18} />
            </a>
            <a href={FACEBOOK_PAGE_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
              <FacebookIcon size={18} />
            </a>
            <a href="https://x.com/raheasy" target="_blank" rel="noopener noreferrer" aria-label="X" className="footer-social-link">
              <XIcon size={18} />
            </a>
            <a href="https://linkedin.com/company/raheasy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="footer-social-link">
              <LinkedInIcon size={18} />
            </a>
            <a href="https://wa.me/254708177021" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="footer-social-link footer-social-link-whatsapp">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#categories">Categories</Link></li>
            <li><Link to="/outlets">Stores & Merchants</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li>
              <Link to="/partner-with-us" className="footer-link-highlight">
                Partner With Us
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Help and Support</h4>
          <ul className="footer-links">
            <li><Link to="/help">Help Center</Link></li>
            <li><Link to="/help#contact-support">Contact Support</Link></li>
            <li><Link to="/help#faqs">FAQs</Link></li>
          </ul>
          <FooterExperienceRating />
        </div>
      </div>

      <div className="footer-contact-bar">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Garden+City+Mall+Nairobi"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-contact-item"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>Garden City Mall, Nairobi</span>
        </a>
        <span className="footer-contact-sep" aria-hidden="true">|</span>
        <a href="tel:254708177021" className="footer-contact-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span>+254 708 177 021</span>
        </a>
        <span className="footer-contact-sep" aria-hidden="true">|</span>
        <a href="mailto:info@raheasy.co.ke" className="footer-contact-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span>info@raheasy.co.ke</span>
        </a>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">&copy; 2024-2026 Raheasy. All rights reserved.</p>
        <div className="footer-legal-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-legal-sep" aria-hidden="true">|</span>
          <Link to="/privacy-policy#terms-of-use">Terms of Use</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
